// extracted by mini-css-extract-plugin
export default {"container":"routeFallback_container__JiG3B","spinner":"routeFallback_spinner__XaU3N","routeSpin":"routeFallback_routeSpin__Ws9qN"};